/**
 * 屏幕分辨率检测工具
 * 实时显示当前窗口的分辨率信息
 */

/**
 * 检测屏幕分辨率并显示在页面上
 */
export function myCheckPx(): void {
  // SSR兼容性检查
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  
  const pageWidth = window.innerWidth;
  const pageHeight = window.innerHeight;
  
  // 移除已存在的检测器
  const existingDetector = document.getElementById('checkWidth');
  if (existingDetector) {
    existingDetector.remove();
  }
  
  // 创建新的检测器
  const detector = document.createElement('div');
  detector.id = 'checkWidth';
  detector.style.cssText = `
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 990009;
    padding: 5px;
    background-color: rgba(0, 0, 0, .5);
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-family: monospace;
  `;
  
  detector.innerHTML = `${pageWidth}<br>${pageHeight}`;
  
  document.body.appendChild(detector);
}

/**
 * 初始化分辨率检测器
 */
export function initScreenDetector(): void {
  // SSR兼容性检查
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  
  // 立即执行一次
  myCheckPx();
  
  // 监听窗口大小变化
  window.addEventListener('resize', myCheckPx);
}

/**
 * 销毁分辨率检测器
 */
export function destroyScreenDetector(): void {
  // SSR兼容性检查
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  
  const detector = document.getElementById('checkWidth');
  if (detector) {
    detector.remove();
  }
  
  window.removeEventListener('resize', myCheckPx);
}